import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React, { PropsWithChildren, ReactElement } from 'react';
import { FlexBox } from '../../shared-components/flex-box';
import './SummaryLayout.scss';

interface Props {
  title?: string | ReactElement;
  subtitle?: string | ReactElement;
  withTopBorder?: boolean,
  labelId?: string;
}

const SummaryLayoutImpl: React.FC<PropsWithChildren<Props>> = props => {
  const {
    title,
    subtitle,
    children,
    withTopBorder = false,
    labelId,
  } = props;

  return (
    <FlexBox
      isFullWidth
      className={`summary-layout ${withTopBorder ? 'summary-layout--with-border-top' : ''}`}
    >
      <FlexBox
        direction='column'
        content='start'
        className='summary-layout__title'
      >
        {
          typeof title === 'string' ? (
            <Text
              id={labelId}
              weight='semibold'
            >
              {title}
            </Text>
          ) : title
        }
        {
          typeof subtitle === 'string' ? (
            <Text
              italic
            >
              {subtitle}
            </Text>
          ) : subtitle
        }
      </FlexBox>
      {children}
    </FlexBox>
  );
}

export const SummaryLayout = observer(SummaryLayoutImpl);
